import PartnerCard from "./PartnerCard";
import { useDeviceType } from "./hooks/useOpenAiGlobal";
import { Partner } from "./types";

interface InlinePartnerListProps {
  partners: Partner[];
  requestorDomain?: string;
  userEmail?: string;
  onEmailSubmitted?: (email: string) => void;
  onShowMore: () => void;
}

const InlinePartnerList = ({
  partners,
  requestorDomain,
  userEmail,
  onEmailSubmitted,
  onShowMore,
}: InlinePartnerListProps) => {
  const displayPartners = partners.slice(0, 3);
  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile";

  return (
    <div className={`rounded-xl animate-slide-up ${isMobile ? "mx-auto max-w-sm" : ""}`}>
      {/* Header */}
      <div className={`mb-5 ${isMobile ? "px-4 text-center" : ""}`}>
        <h2 className="text-xl font-semibold text-foreground">
          Best-fit partners for you
        </h2>
      </div>

      {/* Partner list */}
      <div className={`space-y-3 ${isMobile ? "flex flex-col items-center px-4" : ""}`}>
        {displayPartners.map((partner, index) => (
          <div key={partner.id || partner.name || index} className={isMobile ? "w-full max-w-sm" : "w-full"}>
            <PartnerCard
              partner={partner}
              variant="inline"
              requestorDomain={requestorDomain}
              userEmail={userEmail}
              onEmailSubmitted={onEmailSubmitted}
            />
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-2 pt-2 ${isMobile ? "px-4 text-center" : ""}`}>
        <p className="text-xs text-muted-foreground">
          You can request multiple intros; I'll handle outreach.
        </p>
        {partners.length > 3 && (
          <button
            onClick={onShowMore}
            className="text-sm font-medium text-primary hover:underline transition-all whitespace-nowrap"
          >
            Show more partners
          </button>
        )}
      </div>
    </div>
  );
};

export default InlinePartnerList;
